import { buildClassName, lookupPreset } from "./util";

// id: "71c75f3a-9797-4ac6-9794-66f569df0be3"
// title: "FAQ - Frequently Asked Questions"
// type: :html
// key: "public-faq-page"
// parent_id: nil
export function PublicFaqPage71c75f3a97974ac6979466f569df0be3(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicFaqPage71c75f3a97974ac6979466f569df0be3 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header5047f59c7e764a2d86af3736d9faf343" parentTag={buildClassName("Header5047f59c7e764a2d86af3736d9faf343", parentTag)} className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" type="header_with_hero" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content549306520a774422B42c500fc239caa7" parentTag={buildClassName("Content549306520a774422B42c500fc239caa7", parentTag)} contentSlug="public-faq-main-content" className="main-content" type="post" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterCc1bbfb0E3684e5c97fb7d334b6a56ec" {...props} />}
    </div>
  );
}

// id: "699efbe9-7a1e-4766-952c-80433999e3a5"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "7a8a199c-1b57-46aa-b50b-ce94a3a28449"
export function Header699efbe97a1e4766952c80433999e3a5(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header699efbe97a1e4766952c80433999e3a5" parentTag={buildClassName("Header699efbe97a1e4766952c80433999e3a5", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" as="header" contentSlug="local-partnership-header-with-hero" {...props} />
  );
}

// id: "4a398ff7-b337-477f-9624-4369ab5a6872"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "3c5ef2dd-d3d1-4085-b49e-631167c915e8"
export function Logo4a398ff7B337477f96244369ab5a6872(props: any) {
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo4a398ff7B337477f96244369ab5a6872" parentTag={buildClassName("Logo4a398ff7B337477f96244369ab5a6872", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "b36a8f76-fe24-4c20-aa7e-4d776d11e8f6"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4a398ff7-b337-477f-9624-4369ab5a6872"
export const ContentSlugB36a8f76Fe244c20Aa7e4d776d11e8f6 = "footer-logo";

// id: "90fec781-3c81-4698-9ed4-cff475f64049"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4256bbb9-d1c1-4a9c-89d9-2334dec710ed"
export const ContentSlug90fec7813c8146989ed4Cff475f64049 = "public-contact-header-with-hero";

// id: "7a4a73ed-9036-4918-a1de-0ef437469672"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "4e56279a-2a27-4246-b18f-28a4aca09dce"
export function HeroWrapper7a4a73ed90364918A1de0ef437469672(props: any) {
  const Hero = lookupPreset("Hero");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper7a4a73ed90364918A1de0ef437469672`}>
      {props["hero"] || <Hero className="HeroB67240346e5e45f1A4fbD7388e1e9bff" parentTag={buildClassName("HeroB67240346e5e45f1A4fbD7388e1e9bff", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "284db145-721d-4204-8752-ebbd503ac58e"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "966778b0-e6e6-468e-80db-383126eb4366"
export function Hero284db145721d42048752Ebbd503ac58e(props: any) {
  return (
    <SecondaryMarketingHeroFc6fd8c4877d4d8dBc39144bd7e7bc9c parentTag="Hero284db145721d42048752Ebbd503ac58e" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "6631b8ce-751d-4fee-8335-ee2083232d1a"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "b8460feb-415a-4607-90da-00afa1ff5457"
export const LogoType6631b8ce751d4fee8335Ee2083232d1a = "DEFAULT";

// id: "0beb28c3-dfaf-4fc8-b955-763d31562ecd"
// title: ""
// type: :text
// key: "className"
// parent_id: "1b1d7d0f-d38a-472d-b88b-fb2c2d37d88d"
export const ClassName0beb28c3Dfaf4fc8B955763d31562ecd = "public-header-with-hero secondary-page";

// id: "c19ff8c2-1863-4470-b89a-8027ca6195be"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "653d52c7-0353-4f57-aa1b-105d3b912e96"
export const PostSlugC19ff8c218634470B89a8027ca6195be = "home-page-cards";

// id: "375160b3-4d7a-4a5d-9ff4-8e024161c071"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage375160b34d7a4a5d9ff48e024161c071(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage375160b34d7a4a5d9ff48e024161c071`} classname="gf-page-layout">
      {props["header"] || <ContentItem className="HeaderD1b164f98d514b768db25e0089b18eec" parentTag={buildClassName("HeaderD1b164f98d514b768db25e0089b18eec", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" title="Secondary Page" as="header" contentSlug="join-us-header-with-hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterBa994a6c48294596882e56f439fb3816" {...props} />}
    </div>
  );
}

// id: "4e56279a-2a27-4246-b18f-28a4aca09dce"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function HeaderWrapper4e56279a2a274246B18f28a4aca09dce(props: any) {
  const Hero = lookupPreset("Hero");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper4e56279a2a274246B18f28a4aca09dce`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopAe9f55018a854521A26013943067afa4 parentTag="HeaderTop48e671b904694f20Ac4399f7b9c5ddb4" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper7a4a73ed90364918A1de0ef437469672 />}
    </div>
  );
}

// id: "ba994a6c-4829-4596-882e-56f439fb3816"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "375160b3-4d7a-4a5d-9ff4-8e024161c071"
export function FooterBa994a6c48294596882e56f439fb3816(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterBa994a6c48294596882e56f439fb3816" {...props} />
  );
}

// id: "87d7a07c-2958-42fe-ae02-3f2d7d601753"
// title: ""
// type: :text
// key: "className"
// parent_id: "1dfe6d61-20de-4157-8494-77270998c487"
export const ClassName87d7a07c295842feAe023f2d7d601753 = "public-header-with-hero secondary-page";

// id: "a59487c6-c5cb-41b3-a0d3-be009afd2ce6"
// title: ""
// type: :text
// key: "className"
// parent_id: "699efbe9-7a1e-4766-952c-80433999e3a5"
export const ClassNameA59487c6C5cb41b3A0d3Be009afd2ce6 = "public-header-with-hero secondary-page";

// id: "a7210d72-df18-4283-93ba-104dcd1111f9"
// title: ""
// type: :text
// key: "className"
// parent_id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
export const ClassNameA7210d72Df18428393ba104dcd1111f9 = "public-header-with-hero secondary-page";

// id: "4191c67a-903b-4d2b-8182-c4d67736b5bb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "7688f1d3-62e3-4992-9c06-18d39d420f25"
export const ContentSlug4191c67a903b4d2b8182C4d67736b5bb = "home-page-quote";

// id: "fc6fd8c4-877d-4d8d-bc39-144bd7e7bc9c"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroFc6fd8c4877d4d8dBc39144bd7e7bc9c(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroFc6fd8c4877d4d8dBc39144bd7e7bc9c hero`}>
      <h1 className="title">
        {props["title"] || Title8b766546F32541a392e260370dc92267}
      </h1>
    </div>
  );
}

// id: "4256bbb9-d1c1-4a9c-89d9-2334dec710ed"
// title: "Contact Header"
// type: :gf_preset
// key: "header"
// parent_id: "e526fa51-7d88-42b8-a096-d2e1099604fa"
export function Header4256bbb9D1c14a9c89d92334dec710ed(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header4256bbb9D1c14a9c89d92334dec710ed" parentTag={buildClassName("Header4256bbb9D1c14a9c89d92334dec710ed", parentTag)} contentSlug="public-contact-header-with-hero" type="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "b8460feb-415a-4607-90da-00afa1ff5457"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "ae9f5501-8a85-4521-a260-13943067afa4"
export function LogoB8460feb415a460790da00afa1ff5457(props: any) {
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoB8460feb415a460790da00afa1ff5457" parentTag={buildClassName("LogoB8460feb415a460790da00afa1ff5457", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "f95fe0b4-0e23-4e46-9836-75ea7b6e2658"
// title: ""
// type: :text
// key: "type"
// parent_id: "699efbe9-7a1e-4766-952c-80433999e3a5"
export const TypeF95fe0b40e234e46983675ea7b6e2658 = "header_with_hero";

// id: "058c1e67-6ac4-4975-bd4d-5d65ec156f87"
// title: ""
// type: :text
// key: "type"
// parent_id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
export const Type058c1e676ac44975Bd4d5d65ec156f87 = "header_with_hero";

// id: "53849da3-a1af-45ac-a92e-317b18c74ecd"
// title: ""
// type: :text
// key: "type"
// parent_id: "2a39e373-0d68-432b-9321-ff2690bbff76"
export const Type53849da3A1af45acA92e317b18c74ecd = "header_with_hero";

// id: "0efffda7-236a-42d2-9bf9-e8fee3814247"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b6724034-6e5e-45f1-a4fb-d7388e1e9bff"
export const PostSlug0efffda7236a42d29bf9E8fee3814247 = "home-hero";

// id: "1b1d7d0f-d38a-472d-b88b-fb2c2d37d88d"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "28384af0-3b8a-4021-b846-b253a994cf4e"
export function Header1b1d7d0fD38a472dB88bFb2c2d37d88d(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1b1d7d0fD38a472dB88bFb2c2d37d88d" parentTag={buildClassName("Header1b1d7d0fD38a472dB88bFb2c2d37d88d", parentTag)} className="public-header-with-hero secondary-page" as="header" type="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />
  );
}

// id: "cc1bbfb0-e368-4e5c-97fb-7d334b6a56ec"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "71c75f3a-9797-4ac6-9794-66f569df0be3"
export function FooterCc1bbfb0E3684e5c97fb7d334b6a56ec(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterCc1bbfb0E3684e5c97fb7d334b6a56ec" {...props} />
  );
}

// id: "48e671b9-0469-4f20-ac43-99f7b9c5ddb4"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "4e56279a-2a27-4246-b18f-28a4aca09dce"
export function HeaderTop48e671b904694f20Ac4399f7b9c5ddb4(props: any) {
  return (
    <DefaultHeaderTopAe9f55018a854521A26013943067afa4 parentTag="HeaderTop48e671b904694f20Ac4399f7b9c5ddb4" {...props} />
  );
}

// id: "6a6a8d46-1de9-4057-8e1d-b013f69178f2"
// title: ""
// type: :text
// key: "as"
// parent_id: "1b1d7d0f-d38a-472d-b88b-fb2c2d37d88d"
export const As6a6a8d461de940578e1dB013f69178f2 = "header";

// id: "25127c75-9b91-4b5d-9306-063314a8e565"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "54930652-0a77-4422-b42c-500fc239caa7"
export const ContentSlug25127c759b914b5d9306063314a8e565 = "public-faq-main-content";

// id: "8b766546-f325-41a3-92e2-60370dc92267"
// title: ""
// type: :text
// key: "title"
// parent_id: "fc6fd8c4-877d-4d8d-bc39-144bd7e7bc9c"
export const Title8b766546F32541a392e260370dc92267 = "Default Title";

// id: "dc3f59e2-b9ac-453c-8a6a-f2c813f10d52"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "ae9f5501-8a85-4521-a260-13943067afa4"
export function NavigationDc3f59e2B9ac453c8a6aF2c813f10d52(props: any) {
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationDc3f59e2B9ac453c8a6aF2c813f10d52" parentTag={buildClassName("NavigationDc3f59e2B9ac453c8a6aF2c813f10d52", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "f3bd7b5f-c139-4112-83fd-9e66cf60fb11"
// title: ""
// type: :text
// key: "className"
// parent_id: "d3ce4fec-0d91-4cd9-b7cb-fc548ccd9e1e"
export const ClassNameF3bd7b5fC139411283fd9e66cf60fb11 = "public-header-with-hero home-page";

// id: "ee55b537-a3f5-46e1-92ea-f9ad3559f240"
// title: ""
// type: :text
// key: "className"
// parent_id: "54930652-0a77-4422-b42c-500fc239caa7"
export const ClassNameEe55b537A3f546e192eaF9ad3559f240 = "main-content";

// id: "ca2fb382-2439-4ffb-a45f-a7100d4b82ff"
// title: ""
// type: :text
// key: "title"
// parent_id: "bb4bf21a-1dc2-47e2-bfd2-a330f1925f48"
export const TitleCa2fb38224394ffbA45fA7100d4b82ff = "Join Us";

// id: "c1bb3b0a-6d9b-43fd-879f-7baa4a94f6df"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPagesC1bb3b0a6d9b43fd879f7baa4a94f6df(props: any) {
  return (
    <SecondaryPage375160b34d7a4a5d9ff48e024161c071 parentTag="ApplicationPagesC1bb3b0a6d9b43fd879f7baa4a94f6df" header={<SecondaryMarketingHeader966778b0E6e6468e80db383126eb4366 parentTag="HeaderBb4bf21a1dc247e2Bfd2A330f1925f48" title="Join Us" />} {...props} />
  );
}

// id: "c0c921c6-0149-49df-89a6-bf122242f205"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7a8a199c-1b57-46aa-b50b-ce94a3a28449"
export function FooterC0c921c6014949df89a6Bf122242f205(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterC0c921c6014949df89a6Bf122242f205" {...props} />
  );
}

// id: "a43b4aef-c387-4df9-9ec4-d60135fe0ced"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "966778b0-e6e6-468e-80db-383126eb4366"
export function HeaderTopA43b4aefC3874df99ec4D60135fe0ced(props: any) {
  return (
    <DefaultHeaderTopAe9f55018a854521A26013943067afa4 parentTag="HeaderTopA43b4aefC3874df99ec4D60135fe0ced" {...props} />
  );
}

// id: "44169cbc-116b-418b-ba41-d32938580851"
// title: ""
// type: :text
// key: "class"
// parent_id: "6e959290-6350-4999-8d9e-c9e515defe2f"
export const Class44169cbc116b418bBa41D32938580851 = "main-inner";

// id: "ca6223e6-61cb-41f9-8caf-8fab28e11036"
// title: ""
// type: :text
// key: "type"
// parent_id: "c524732f-55c5-488b-85f5-9a5a11645c0d"
export const TypeCa6223e661cb41f98caf8fab28e11036 = "post";

// id: "7688f1d3-62e3-4992-9c06-18d39d420f25"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "7ca72cca-16b8-4201-8fe2-37bbeb0a7d7e"
export function Quote7688f1d362e349929c0618d39d420f25(props: any) {
  const PageQuote = lookupPreset("PageQuote");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote7688f1d362e349929c0618d39d420f25" parentTag={buildClassName("Quote7688f1d362e349929c0618d39d420f25", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "5e4d1d65-9861-4a70-9450-8c7c94f6c748"
// title: ""
// type: :text
// key: "type"
// parent_id: "1b1d7d0f-d38a-472d-b88b-fb2c2d37d88d"
export const Type5e4d1d6598614a7094508c7c94f6c748 = "header_with_hero";

// id: "ae9f5501-8a85-4521-a260-13943067afa4"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopAe9f55018a854521A26013943067afa4(props: any) {
  const Link = lookupPreset("Link");
  const Logo = lookupPreset("Logo");
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopAe9f55018a854521A26013943067afa4 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518" parentTag={buildClassName("LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518", parentTag)} url="/" className="linked-logo" label={<Logo className="Label51f9b06cC7f04e2fA672C827c6e9a666" parentTag={buildClassName("Label51f9b06cC7f04e2fA672C827c6e9a666", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationDc3f59e2B9ac453c8a6aF2c813f10d52" parentTag={buildClassName("NavigationDc3f59e2B9ac453c8a6aF2c813f10d52", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "54930652-0a77-4422-b42c-500fc239caa7"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "71c75f3a-9797-4ac6-9794-66f569df0be3"
export function Content549306520a774422B42c500fc239caa7(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content549306520a774422B42c500fc239caa7" parentTag={buildClassName("Content549306520a774422B42c500fc239caa7", parentTag)} contentSlug="public-faq-main-content" className="main-content" type="post" {...props} />
  );
}

// id: "cc02e735-7900-4157-981b-e781b3fc3b8a"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "3c5ef2dd-d3d1-4085-b49e-631167c915e8"
export function GroupflowCc02e73579004157981bE781b3fc3b8a(props: any) {
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowCc02e73579004157981bE781b3fc3b8a" parentTag={buildClassName("GroupflowCc02e73579004157981bE781b3fc3b8a", parentTag)} {...props} />
  );
}

// id: "6e13606c-4434-4432-93ec-b7fa960ad452"
// title: ""
// type: :text
// key: "className"
// parent_id: "5047f59c-7e76-4a2d-86af-3736d9faf343"
export const ClassName6e13606c4434443293ecB7fa960ad452 = "public-header-with-hero secondary-page";

// id: "29f53e73-3336-4a7a-8460-4194bb2e1c88"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "51f9b06c-c7f0-4e2f-a672-c827c6e9a666"
export const LogoType29f53e7333364a7a84604194bb2e1c88 = "DEFAULT";

// id: "7a8a199c-1b57-46aa-b50b-ce94a3a28449"
// title: "Local Partnership"
// type: :html
// key: "local-partnership-page"
// parent_id: nil
export function LocalPartnershipPage7a8a199c1b5746aaB50bCe94a3a28449(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const PageContentSimplified = lookupPreset("PageContentSimplified");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} LocalPartnershipPage7a8a199c1b5746aaB50bCe94a3a28449 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header699efbe97a1e4766952c80433999e3a5" parentTag={buildClassName("Header699efbe97a1e4766952c80433999e3a5", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" as="header" contentSlug="local-partnership-header-with-hero" {...props} />}
      <main>
        {props["page-content"] || <PageContentSimplified className="PageContent6e959290635049998d9eC9e515defe2f" parentTag={buildClassName("PageContent6e959290635049998d9eC9e515defe2f", parentTag)} className="main-inner" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterC0c921c6014949df89a6Bf122242f205" {...props} />}
    </div>
  );
}

// id: "dff9969b-9640-4e7b-a12f-c094d785057a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "e526fa51-7d88-42b8-a096-d2e1099604fa"
export function FooterDff9969b96404e7bA12fC094d785057a(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterDff9969b96404e7bA12fC094d785057a" {...props} />
  );
}

// id: "12d41b3f-cefb-410c-962e-cd14007f7af5"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "28384af0-3b8a-4021-b846-b253a994cf4e"
export function Footer12d41b3fCefb410c962eCd14007f7af5(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer12d41b3fCefb410c962eCd14007f7af5" {...props} />
  );
}

// id: "7b0f221b-f5c8-46a3-8e1b-7cb28edd6e97"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "091839fa-a503-4208-bdfa-6ea88b81a7c8"
export const NavMenuSlug7b0f221bF5c846a38e1b7cb28edd6e97 = "footer-nav";

// id: "44c3642c-3692-4eb9-8a88-425cd35e9ae8"
// title: ""
// type: :text
// key: "className"
// parent_id: "c524732f-55c5-488b-85f5-9a5a11645c0d"
export const ClassName44c3642c36924eb98a88425cd35e9ae8 = "main-content";

// id: "d34a526b-f906-42c9-a1a5-b7926db0c891"
// title: ""
// type: :text
// key: "class"
// parent_id: "dc3f59e2-b9ac-453c-8a6a-f2c813f10d52"
export const ClassD34a526bF90642c9A1a5B7926db0c891 = "navigation";

// id: "66bfcc34-14fd-44ee-b944-02301a7fc6aa"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "89a4aa66-a3f7-4f2b-b3cc-a8f037ace911"
export const PostSlug66bfcc3414fd44eeB94402301a7fc6aa = "about-us-cards";

// id: "3c5ef2dd-d3d1-4085-b49e-631167c915e8"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter3c5ef2ddD3d14085B49e631167c915e8(props: any) {
  const Navigation = lookupPreset("Navigation");
  const Logo = lookupPreset("Logo");
  const GroupCopyright = lookupPreset("GroupCopyright");
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 footer`}>
      {props["links"] || <Navigation className="Links091839faA5034208Bdfa6ea88b81a7c8" parentTag={buildClassName("Links091839faA5034208Bdfa6ea88b81a7c8", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo4a398ff7B337477f96244369ab5a6872" parentTag={buildClassName("Logo4a398ff7B337477f96244369ab5a6872", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright9139421f684b4c6eAa25Adab5829dacc" parentTag={buildClassName("Copyright9139421f684b4c6eAa25Adab5829dacc", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowCc02e73579004157981bE781b3fc3b8a" parentTag={buildClassName("GroupflowCc02e73579004157981bE781b3fc3b8a", parentTag)} {...props} />}
    </footer>
  );
}

// id: "5a3e3d1d-7baa-4597-a162-27340d28367a"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function WelcomeBack5a3e3d1d7baa4597A16227340d28367a(props: any) {
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack5a3e3d1d7baa4597A16227340d28367a" parentTag={buildClassName("WelcomeBack5a3e3d1d7baa4597A16227340d28367a", parentTag)} {...props} />
  );
}

// id: "66e6cb10-20de-47db-8b88-382bd8dceb6f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d3ce4fec-0d91-4cd9-b7cb-fc548ccd9e1e"
export const ContentSlug66e6cb1020de47db8b88382bd8dceb6f = "home-header-with-hero";

// id: "51167f47-97f2-4471-93b2-f2718a2d9bba"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5047f59c-7e76-4a2d-86af-3736d9faf343"
export const ContentSlug51167f4797f2447193b2F2718a2d9bba = "public-faq-header-with-hero";

// id: "5518b167-61e9-47a1-880e-47df6027fc32"
// title: ""
// type: :text
// key: "url"
// parent_id: "3e6a8d4c-c80f-4c5e-b758-9d4f41bf1518"
export const Url5518b16761e947a1880e47df6027fc32 = "/";

// id: "f47a48ab-8019-497a-8097-ef637d269ad3"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "51f9b06c-c7f0-4e2f-a672-c827c6e9a666"
export const ContentSlugF47a48ab8019497a8097Ef637d269ad3 = "header-logo";

// id: "966778b0-e6e6-468e-80db-383126eb4366"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader966778b0E6e6468e80db383126eb4366(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader966778b0E6e6468e80db383126eb4366 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopAe9f55018a854521A26013943067afa4 parentTag="HeaderTopA43b4aefC3874df99ec4D60135fe0ced" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroFc6fd8c4877d4d8dBc39144bd7e7bc9c parentTag="Hero284db145721d42048752Ebbd503ac58e" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "51632dd1-6a86-4a9f-97c1-7244254c9cfa"
// title: ""
// type: :text
// key: "title"
// parent_id: "966778b0-e6e6-468e-80db-383126eb4366"
export const Title51632dd16a864a9f97c17244254c9cfa = "Secondary Marketing Title 1";

// id: "c524732f-55c5-488b-85f5-9a5a11645c0d"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "e526fa51-7d88-42b8-a096-d2e1099604fa"
export function ContentC524732f55c5488b85f59a5a11645c0d(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="ContentC524732f55c5488b85f59a5a11645c0d" parentTag={buildClassName("ContentC524732f55c5488b85f59a5a11645c0d", parentTag)} type="post" className="main-content" contentSlug="public-contact-main-content" {...props} />
  );
}

// id: "589e74d0-55ca-4a68-ab67-d9e71a37932d"
// title: ""
// type: :text
// key: "className"
// parent_id: "2a39e373-0d68-432b-9321-ff2690bbff76"
export const ClassName589e74d055ca4a68Ab67D9e71a37932d = "public-header-with-hero secondary-page";

// id: "06a857dc-5162-43c8-b009-f034c85ca554"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "dc3f59e2-b9ac-453c-8a6a-f2c813f10d52"
export const NavMenuSlug06a857dc516243c8B009F034c85ca554 = "marketing-primary-nav";

// id: "4da40ee8-7793-4f2e-950b-b093b92022ef"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "653d52c7-0353-4f57-aa1b-105d3b912e96"
export const ButtonClass4da40ee877934f2e950bB093b92022ef = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "b44dbfb9-edce-4ae7-aaa9-4b2b7bc145fc"
// title: ""
// type: :text
// key: "type"
// parent_id: "1dfe6d61-20de-4157-8494-77270998c487"
export const TypeB44dbfb9Edce4ae7Aaa94b2b7bc145fc = "header_with_hero";

// id: "6d514c92-a76d-4abb-871c-46b0286fb4f2"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage6d514c92A76d4abb871c46b0286fb4f2(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage6d514c92A76d4abb871c46b0286fb4f2 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header1dfe6d6120de4157849477270998c487" parentTag={buildClassName("Header1dfe6d6120de4157849477270998c487", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" contentSlug="about-us-header-with-hero" as="header" {...props} />}
      {props["main"] || <MainE159622b61f8492eA8d2922371a1f5a7 />}
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer2fab9d212b994c7b8373B27fc4f5e0e4" {...props} />}
    </div>
  );
}

// id: "e84bcccc-3908-4eb3-b4eb-a93f18a81533"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6ee7d8ad-c176-4f1e-b263-5ceabf54bab7"
export function FooterE84bcccc39084eb3B4ebA93f18a81533(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterE84bcccc39084eb3B4ebA93f18a81533" {...props} />
  );
}

// id: "e159622b-61f8-492e-a8d2-922371a1f5a7"
// title: ""
// type: :html
// key: "main"
// parent_id: "6d514c92-a76d-4abb-871c-46b0286fb4f2"
export function MainE159622b61f8492eA8d2922371a1f5a7(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainE159622b61f8492eA8d2922371a1f5a7`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards89a4aa66A3f74f2bB3ccA8f037ace911" parentTag={buildClassName("Cards89a4aa66A3f74f2bB3ccA8f037ace911", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "81de0fc7-1cfb-42ea-ba76-7b650429d4bb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "da52780e-ac7e-4e08-826c-2e4117ec4631"
export const ContentSlug81de0fc71cfb42eaBa767b650429d4bb = "home-page-quote";

// id: "63a6c6f9-beac-4f4f-99e4-febdadaa4148"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1b1d7d0f-d38a-472d-b88b-fb2c2d37d88d"
export const ContentSlug63a6c6f9Beac4f4f99e4Febdadaa4148 = "join-us-header-with-hero";

// id: "fa0883a6-2e2b-4e17-bd88-eb24dcc5ce3f"
// title: ""
// type: :text
// key: "type"
// parent_id: "54930652-0a77-4422-b42c-500fc239caa7"
export const TypeFa0883a62e2b4e17Bd88Eb24dcc5ce3f = "post";

// id: "6ee7d8ad-c176-4f1e-b263-5ceabf54bab7"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage6ee7d8adC1764f1eB2635ceabf54bab7(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage6ee7d8adC1764f1eB2635ceabf54bab7`}>
      {props["header"] || <ContentItem className="Header2a39e3730d68432b9321Ff2690bbff76" parentTag={buildClassName("Header2a39e3730d68432b9321Ff2690bbff76", parentTag)} type="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="public-events-header-with-hero" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterE84bcccc39084eb3B4ebA93f18a81533" {...props} />}
    </div>
  );
}

// id: "091839fa-a503-4208-bdfa-6ea88b81a7c8"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "3c5ef2dd-d3d1-4085-b49e-631167c915e8"
export function Links091839faA5034208Bdfa6ea88b81a7c8(props: any) {
  const Navigation = lookupPreset("Navigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links091839faA5034208Bdfa6ea88b81a7c8" parentTag={buildClassName("Links091839faA5034208Bdfa6ea88b81a7c8", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "9139421f-684b-4c6e-aa25-adab5829dacc"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "3c5ef2dd-d3d1-4085-b49e-631167c915e8"
export function Copyright9139421f684b4c6eAa25Adab5829dacc(props: any) {
  const GroupCopyright = lookupPreset("GroupCopyright");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright9139421f684b4c6eAa25Adab5829dacc" parentTag={buildClassName("Copyright9139421f684b4c6eAa25Adab5829dacc", parentTag)} {...props} />
  );
}

// id: "0dcc63ae-4854-4886-b792-9ad74bb4dd58"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "4a398ff7-b337-477f-9624-4369ab5a6872"
export const LogoType0dcc63ae48544886B7929ad74bb4dd58 = "FOOTER";

// id: "ce167340-3d5b-4d73-8d55-5ffe3f025fe5"
// title: ""
// type: :text
// key: "class"
// parent_id: "3e6a8d4c-c80f-4c5e-b758-9d4f41bf1518"
export const ClassCe1673403d5b4d738d555ffe3f025fe5 = "linked-logo";

// id: "c59f5804-4d3d-47d5-ac72-5ee954c51e59"
// title: ""
// type: :text
// key: "type"
// parent_id: "4256bbb9-d1c1-4a9c-89d9-2334dec710ed"
export const TypeC59f58044d3d47d5Ac725ee954c51e59 = "header_with_hero";

// id: "28384af0-3b8a-4021-b846-b253a994cf4e"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage28384af03b8a4021B846B253a994cf4e(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPage28384af03b8a4021B846B253a994cf4e`}>
      {props["header"] || <ContentItem className="Header1b1d7d0fD38a472dB88bFb2c2d37d88d" parentTag={buildClassName("Header1b1d7d0fD38a472dB88bFb2c2d37d88d", parentTag)} className="public-header-with-hero secondary-page" as="header" type="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer12d41b3fCefb410c962eCd14007f7af5" {...props} />}
    </div>
  );
}

// id: "d3ce4fec-0d91-4cd9-b7cb-fc548ccd9e1e"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e" parentTag={buildClassName("HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e", parentTag)} className="public-header-with-hero home-page" contentSlug="home-header-with-hero" as="header" type="header_with_hero" {...props} />
  );
}

// id: "5b229014-a98c-4cb0-8e9d-e0363c8ebc7d"
// title: ""
// type: :text
// key: "as"
// parent_id: "d3ce4fec-0d91-4cd9-b7cb-fc548ccd9e1e"
export const As5b229014A98c4cb08e9dE0363c8ebc7d = "header";

// id: "a546a9c5-2d2f-413e-8cd6-673fedb41cbe"
// title: ""
// type: :text
// key: "as"
// parent_id: "5047f59c-7e76-4a2d-86af-3736d9faf343"
export const AsA546a9c52d2f413e8cd6673fedb41cbe = "header";

// id: "653d52c7-0353-4f57-aa1b-105d3b912e96"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "7ca72cca-16b8-4201-8fe2-37bbeb0a7d7e"
export function Cards653d52c703534f57Aa1b105d3b912e96(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards653d52c703534f57Aa1b105d3b912e96" parentTag={buildClassName("Cards653d52c703534f57Aa1b105d3b912e96", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "e526fa51-7d88-42b8-a096-d2e1099604fa"
// title: "Contact Us"
// type: :html
// key: "public-contact-page"
// parent_id: nil
export function PublicContactPageE526fa517d8842b8A096D2e1099604fa(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicContactPageE526fa517d8842b8A096D2e1099604fa gf-page-layout`}>
      {props["header"] || <ContentItem className="Header4256bbb9D1c14a9c89d92334dec710ed" parentTag={buildClassName("Header4256bbb9D1c14a9c89d92334dec710ed", parentTag)} contentSlug="public-contact-header-with-hero" type="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["content"] || <ContentItem className="ContentC524732f55c5488b85f59a5a11645c0d" parentTag={buildClassName("ContentC524732f55c5488b85f59a5a11645c0d", parentTag)} type="post" className="main-content" contentSlug="public-contact-main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="FooterDff9969b96404e7bA12fC094d785057a" {...props} />}
    </div>
  );
}

// id: "3e6a8d4c-c80f-4c5e-b758-9d4f41bf1518"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "ae9f5501-8a85-4521-a260-13943067afa4"
export function LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518(props: any) {
  const Link = lookupPreset("Link");
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518" parentTag={buildClassName("LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518", parentTag)} url="/" className="linked-logo" label={<Logo className="Label51f9b06cC7f04e2fA672C827c6e9a666" parentTag={buildClassName("Label51f9b06cC7f04e2fA672C827c6e9a666", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} {...props} />
  );
}

// id: "bb4bf21a-1dc2-47e2-bfd2-a330f1925f48"
// title: ""
// type: :reference
// key: "header"
// parent_id: "c1bb3b0a-6d9b-43fd-879f-7baa4a94f6df"
export function HeaderBb4bf21a1dc247e2Bfd2A330f1925f48(props: any) {
  return (
    <SecondaryMarketingHeader966778b0E6e6468e80db383126eb4366 parentTag="HeaderBb4bf21a1dc247e2Bfd2A330f1925f48" title="Join Us" {...props} />
  );
}

// id: "66c093f6-9244-429d-b390-083dc2a43d3e"
// title: ""
// type: :text
// key: "as"
// parent_id: "4256bbb9-d1c1-4a9c-89d9-2334dec710ed"
export const As66c093f69244429dB390083dc2a43d3e = "header";

// id: "ffd65432-d96b-4e96-a7e0-356f9912656c"
// title: ""
// type: :text
// key: "title"
// parent_id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
export const TitleFfd65432D96b4e96A7e0356f9912656c = "Secondary Page";

// id: "e372dee0-5239-439e-bec1-9e792a019aa5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1dfe6d61-20de-4157-8494-77270998c487"
export const ContentSlugE372dee05239439eBec19e792a019aa5 = "about-us-header-with-hero";

// id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage9feb9963Cd9445f6A5ad064d03fb1d63(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const PageQuote = lookupPreset("PageQuote");
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage9feb9963Cd9445f6A5ad064d03fb1d63 gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e" parentTag={buildClassName("HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e", parentTag)} className="public-header-with-hero home-page" contentSlug="home-header-with-hero" as="header" type="header_with_hero" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack5a3e3d1d7baa4597A16227340d28367a" parentTag={buildClassName("WelcomeBack5a3e3d1d7baa4597A16227340d28367a", parentTag)} {...props} />}
      {props["main"] || <Main7ca72cca16b842018fe237bbeb0a7d7e />}
      {props["footer"] || <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer6574065867574dabA7b668aeeddd0ae1" {...props} />}
    </div>
  );
}

// id: "2fab9d21-2b99-4c7b-8373-b27fc4f5e0e4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6d514c92-a76d-4abb-871c-46b0286fb4f2"
export function Footer2fab9d212b994c7b8373B27fc4f5e0e4(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer2fab9d212b994c7b8373B27fc4f5e0e4" {...props} />
  );
}

// id: "65740658-6757-4dab-a7b6-68aeeddd0ae1"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function Footer6574065867574dabA7b668aeeddd0ae1(props: any) {
  return (
    <DefaultFooter3c5ef2ddD3d14085B49e631167c915e8 parentTag="Footer6574065867574dabA7b668aeeddd0ae1" {...props} />
  );
}

// id: "0d80de49-d3b9-4eb0-bdb0-d140cba1e961"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "c524732f-55c5-488b-85f5-9a5a11645c0d"
export const ContentSlug0d80de49D3b94eb0Bdb0D140cba1e961 = "public-contact-main-content";

// id: "51f9b06c-c7f0-4e2f-a672-c827c6e9a666"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "3e6a8d4c-c80f-4c5e-b758-9d4f41bf1518"
export function Label51f9b06cC7f04e2fA672C827c6e9a666(props: any) {
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Label51f9b06cC7f04e2fA672C827c6e9a666" parentTag={buildClassName("Label51f9b06cC7f04e2fA672C827c6e9a666", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "b1b02a8a-cf9d-4749-a702-083922e2abc3"
// title: ""
// type: :text
// key: "type"
// parent_id: "d3ce4fec-0d91-4cd9-b7cb-fc548ccd9e1e"
export const TypeB1b02a8aCf9d4749A702083922e2abc3 = "header_with_hero";

// id: "6e959290-6350-4999-8d9e-c9e515defe2f"
// title: "Local Partnership - Page Content"
// type: :gf_preset
// key: "page-content"
// parent_id: "7a8a199c-1b57-46aa-b50b-ce94a3a28449"
export function PageContent6e959290635049998d9eC9e515defe2f(props: any) {
  const PageContentSimplified = lookupPreset("PageContentSimplified");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="PageContent6e959290635049998d9eC9e515defe2f" parentTag={buildClassName("PageContent6e959290635049998d9eC9e515defe2f", parentTag)} className="main-inner" {...props} />
  );
}

// id: "01f490dd-bbd6-442e-8a48-f7d4167741ae"
// title: ""
// type: :text
// key: "as"
// parent_id: "699efbe9-7a1e-4766-952c-80433999e3a5"
export const As01f490ddBbd6442e8a48F7d4167741ae = "header";

// id: "620c0683-559e-49a7-8d17-e2cc7ed772b6"
// title: ""
// type: :text
// key: "as"
// parent_id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
export const As620c0683559e49a78d17E2cc7ed772b6 = "header";

// id: "bd287286-bdb6-4d67-a051-74cabd1ecb3e"
// title: ""
// type: :text
// key: "as"
// parent_id: "2a39e373-0d68-432b-9321-ff2690bbff76"
export const AsBd287286Bdb64d67A05174cabd1ecb3e = "header";

// id: "2a39e373-0d68-432b-9321-ff2690bbff76"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "6ee7d8ad-c176-4f1e-b263-5ceabf54bab7"
export function Header2a39e3730d68432b9321Ff2690bbff76(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header2a39e3730d68432b9321Ff2690bbff76" parentTag={buildClassName("Header2a39e3730d68432b9321Ff2690bbff76", parentTag)} type="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="public-events-header-with-hero" title="Public Events" {...props} />
  );
}

// id: "7ca72cca-16b8-4201-8fe2-37bbeb0a7d7e"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function Main7ca72cca16b842018fe237bbeb0a7d7e(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const PageQuote = lookupPreset("PageQuote");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main7ca72cca16b842018fe237bbeb0a7d7e`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards653d52c703534f57Aa1b105d3b912e96" parentTag={buildClassName("Cards653d52c703534f57Aa1b105d3b912e96", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />}
      </div>
      {props["quote"] || <PageQuote className="Quote7688f1d362e349929c0618d39d420f25" parentTag={buildClassName("Quote7688f1d362e349929c0618d39d420f25", parentTag)} contentSlug="home-page-quote" {...props} />}
    </main>
  );
}

// id: "89a4aa66-a3f7-4f2b-b3cc-a8f037ace911"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "e159622b-61f8-492e-a8d2-922371a1f5a7"
export function Cards89a4aa66A3f74f2bB3ccA8f037ace911(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards89a4aa66A3f74f2bB3ccA8f037ace911" parentTag={buildClassName("Cards89a4aa66A3f74f2bB3ccA8f037ace911", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "89834b86-2177-421d-be77-d4ce5c5c27f4"
// title: ""
// type: :text
// key: "title"
// parent_id: "284db145-721d-4204-8752-ebbd503ac58e"
export const Title89834b862177421dBe77D4ce5c5c27f4 = "Secondary Marketing Title 2";

// id: "77d0f179-10e0-4acf-b3df-428e55cb5880"
// title: ""
// type: :text
// key: "className"
// parent_id: "4256bbb9-d1c1-4a9c-89d9-2334dec710ed"
export const ClassName77d0f17910e04acfB3df428e55cb5880 = "public-header-with-hero secondary-page";

// id: "b6724034-6e5e-45f1-a4fb-d7388e1e9bff"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "7a4a73ed-9036-4918-a1de-0ef437469672"
export function HeroB67240346e5e45f1A4fbD7388e1e9bff(props: any) {
  const Hero = lookupPreset("Hero");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroB67240346e5e45f1A4fbD7388e1e9bff" parentTag={buildClassName("HeroB67240346e5e45f1A4fbD7388e1e9bff", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "375160b3-4d7a-4a5d-9ff4-8e024161c071"
export function HeaderD1b164f98d514b768db25e0089b18eec(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderD1b164f98d514b768db25e0089b18eec" parentTag={buildClassName("HeaderD1b164f98d514b768db25e0089b18eec", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" title="Secondary Page" as="header" contentSlug="join-us-header-with-hero" {...props} />
  );
}

// id: "da52780e-ac7e-4e08-826c-2e4117ec4631"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "9feb9963-cd94-45f6-a5ad-064d03fb1d63"
export function QuoteDa52780eAc7e4e08826c2e4117ec4631(props: any) {
  const PageQuote = lookupPreset("PageQuote");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteDa52780eAc7e4e08826c2e4117ec4631" parentTag={buildClassName("QuoteDa52780eAc7e4e08826c2e4117ec4631", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "fc96dd5e-be03-42b2-80f2-29754640da0d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "699efbe9-7a1e-4766-952c-80433999e3a5"
export const ContentSlugFc96dd5eBe0342b280f229754640da0d = "local-partnership-header-with-hero";

// id: "f0600812-22d8-46b0-80ba-45cd81ef829d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d1b164f9-8d51-4b76-8db2-5e0089b18eec"
export const ContentSlugF060081222d846b080ba45cd81ef829d = "join-us-header-with-hero";

// id: "117d78d4-48ba-4c22-ba90-12a7d9aadaff"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "2a39e373-0d68-432b-9321-ff2690bbff76"
export const ContentSlug117d78d448ba4c22Ba9012a7d9aadaff = "public-events-header-with-hero";

// id: "1dfe6d61-20de-4157-8494-77270998c487"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "6d514c92-a76d-4abb-871c-46b0286fb4f2"
export function Header1dfe6d6120de4157849477270998c487(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1dfe6d6120de4157849477270998c487" parentTag={buildClassName("Header1dfe6d6120de4157849477270998c487", parentTag)} className="public-header-with-hero secondary-page" type="header_with_hero" contentSlug="about-us-header-with-hero" as="header" {...props} />
  );
}

// id: "5047f59c-7e76-4a2d-86af-3736d9faf343"
// title: "Contact Header Clone CEM6GZI2IPRP07Y1J"
// type: :gf_preset
// key: "header"
// parent_id: "71c75f3a-9797-4ac6-9794-66f569df0be3"
export function Header5047f59c7e764a2d86af3736d9faf343(props: any) {
  const ContentItem = lookupPreset("ContentItem");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header5047f59c7e764a2d86af3736d9faf343" parentTag={buildClassName("Header5047f59c7e764a2d86af3736d9faf343", parentTag)} className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" type="header_with_hero" {...props} />
  );
}

// id: "bf4f9dc3-9e1d-43f4-96f2-82bc670e3703"
// title: ""
// type: :text
// key: "title"
// parent_id: "2a39e373-0d68-432b-9321-ff2690bbff76"
export const TitleBf4f9dc39e1d43f496f282bc670e3703 = "Public Events";

// id: "62da5cc7-5af6-43e6-a1ba-50e41258508a"
// title: ""
// type: :text
// key: "as"
// parent_id: "1dfe6d61-20de-4157-8494-77270998c487"
export const As62da5cc75af643e6A1ba50e41258508a = "header";

// id: "c653df77-97e4-4624-93af-ad11e96e66cd"
// title: ""
// type: :text
// key: "type"
// parent_id: "5047f59c-7e76-4a2d-86af-3736d9faf343"
export const TypeC653df7797e4462493afAd11e96e66cd = "header_with_hero";

const Components = {
  PublicFaqPage71c75f3a97974ac6979466f569df0be3,
  Header699efbe97a1e4766952c80433999e3a5,
  Logo4a398ff7B337477f96244369ab5a6872,
  ContentSlugB36a8f76Fe244c20Aa7e4d776d11e8f6,
  ContentSlug90fec7813c8146989ed4Cff475f64049,
  HeroWrapper7a4a73ed90364918A1de0ef437469672,
  Hero284db145721d42048752Ebbd503ac58e,
  LogoType6631b8ce751d4fee8335Ee2083232d1a,
  ClassName0beb28c3Dfaf4fc8B955763d31562ecd,
  PostSlugC19ff8c218634470B89a8027ca6195be,
  SecondaryPage375160b34d7a4a5d9ff48e024161c071,
  HeaderWrapper4e56279a2a274246B18f28a4aca09dce,
  FooterBa994a6c48294596882e56f439fb3816,
  ClassName87d7a07c295842feAe023f2d7d601753,
  ClassNameA59487c6C5cb41b3A0d3Be009afd2ce6,
  ClassNameA7210d72Df18428393ba104dcd1111f9,
  ContentSlug4191c67a903b4d2b8182C4d67736b5bb,
  SecondaryMarketingHeroFc6fd8c4877d4d8dBc39144bd7e7bc9c,
  Header4256bbb9D1c14a9c89d92334dec710ed,
  LogoB8460feb415a460790da00afa1ff5457,
  TypeF95fe0b40e234e46983675ea7b6e2658,
  Type058c1e676ac44975Bd4d5d65ec156f87,
  Type53849da3A1af45acA92e317b18c74ecd,
  PostSlug0efffda7236a42d29bf9E8fee3814247,
  Header1b1d7d0fD38a472dB88bFb2c2d37d88d,
  FooterCc1bbfb0E3684e5c97fb7d334b6a56ec,
  HeaderTop48e671b904694f20Ac4399f7b9c5ddb4,
  As6a6a8d461de940578e1dB013f69178f2,
  ContentSlug25127c759b914b5d9306063314a8e565,
  Title8b766546F32541a392e260370dc92267,
  NavigationDc3f59e2B9ac453c8a6aF2c813f10d52,
  ClassNameF3bd7b5fC139411283fd9e66cf60fb11,
  ClassNameEe55b537A3f546e192eaF9ad3559f240,
  TitleCa2fb38224394ffbA45fA7100d4b82ff,
  ApplicationPagesC1bb3b0a6d9b43fd879f7baa4a94f6df,
  FooterC0c921c6014949df89a6Bf122242f205,
  HeaderTopA43b4aefC3874df99ec4D60135fe0ced,
  Class44169cbc116b418bBa41D32938580851,
  TypeCa6223e661cb41f98caf8fab28e11036,
  Quote7688f1d362e349929c0618d39d420f25,
  Type5e4d1d6598614a7094508c7c94f6c748,
  DefaultHeaderTopAe9f55018a854521A26013943067afa4,
  Content549306520a774422B42c500fc239caa7,
  GroupflowCc02e73579004157981bE781b3fc3b8a,
  ClassName6e13606c4434443293ecB7fa960ad452,
  LogoType29f53e7333364a7a84604194bb2e1c88,
  LocalPartnershipPage7a8a199c1b5746aaB50bCe94a3a28449,
  FooterDff9969b96404e7bA12fC094d785057a,
  Footer12d41b3fCefb410c962eCd14007f7af5,
  NavMenuSlug7b0f221bF5c846a38e1b7cb28edd6e97,
  ClassName44c3642c36924eb98a88425cd35e9ae8,
  ClassD34a526bF90642c9A1a5B7926db0c891,
  PostSlug66bfcc3414fd44eeB94402301a7fc6aa,
  DefaultFooter3c5ef2ddD3d14085B49e631167c915e8,
  WelcomeBack5a3e3d1d7baa4597A16227340d28367a,
  ContentSlug66e6cb1020de47db8b88382bd8dceb6f,
  ContentSlug51167f4797f2447193b2F2718a2d9bba,
  Url5518b16761e947a1880e47df6027fc32,
  ContentSlugF47a48ab8019497a8097Ef637d269ad3,
  SecondaryMarketingHeader966778b0E6e6468e80db383126eb4366,
  Title51632dd16a864a9f97c17244254c9cfa,
  ContentC524732f55c5488b85f59a5a11645c0d,
  ClassName589e74d055ca4a68Ab67D9e71a37932d,
  NavMenuSlug06a857dc516243c8B009F034c85ca554,
  ButtonClass4da40ee877934f2e950bB093b92022ef,
  TypeB44dbfb9Edce4ae7Aaa94b2b7bc145fc,
  AboutUsPage6d514c92A76d4abb871c46b0286fb4f2,
  FooterE84bcccc39084eb3B4ebA93f18a81533,
  MainE159622b61f8492eA8d2922371a1f5a7,
  ContentSlug81de0fc71cfb42eaBa767b650429d4bb,
  ContentSlug63a6c6f9Beac4f4f99e4Febdadaa4148,
  TypeFa0883a62e2b4e17Bd88Eb24dcc5ce3f,
  PublicEventsPage6ee7d8adC1764f1eB2635ceabf54bab7,
  Links091839faA5034208Bdfa6ea88b81a7c8,
  Copyright9139421f684b4c6eAa25Adab5829dacc,
  LogoType0dcc63ae48544886B7929ad74bb4dd58,
  ClassCe1673403d5b4d738d555ffe3f025fe5,
  TypeC59f58044d3d47d5Ac725ee954c51e59,
  JoinUsPage28384af03b8a4021B846B253a994cf4e,
  HeaderD3ce4fec0d914cd9B7cbFc548ccd9e1e,
  As5b229014A98c4cb08e9dE0363c8ebc7d,
  AsA546a9c52d2f413e8cd6673fedb41cbe,
  Cards653d52c703534f57Aa1b105d3b912e96,
  PublicContactPageE526fa517d8842b8A096D2e1099604fa,
  LinkedLogo3e6a8d4cC80f4c5eB7589d4f41bf1518,
  HeaderBb4bf21a1dc247e2Bfd2A330f1925f48,
  As66c093f69244429dB390083dc2a43d3e,
  TitleFfd65432D96b4e96A7e0356f9912656c,
  ContentSlugE372dee05239439eBec19e792a019aa5,
  HomePage9feb9963Cd9445f6A5ad064d03fb1d63,
  Footer2fab9d212b994c7b8373B27fc4f5e0e4,
  Footer6574065867574dabA7b668aeeddd0ae1,
  ContentSlug0d80de49D3b94eb0Bdb0D140cba1e961,
  Label51f9b06cC7f04e2fA672C827c6e9a666,
  TypeB1b02a8aCf9d4749A702083922e2abc3,
  PageContent6e959290635049998d9eC9e515defe2f,
  As01f490ddBbd6442e8a48F7d4167741ae,
  As620c0683559e49a78d17E2cc7ed772b6,
  AsBd287286Bdb64d67A05174cabd1ecb3e,
  Header2a39e3730d68432b9321Ff2690bbff76,
  Main7ca72cca16b842018fe237bbeb0a7d7e,
  Cards89a4aa66A3f74f2bB3ccA8f037ace911,
  Title89834b862177421dBe77D4ce5c5c27f4,
  ClassName77d0f17910e04acfB3df428e55cb5880,
  HeroB67240346e5e45f1A4fbD7388e1e9bff,
  HeaderD1b164f98d514b768db25e0089b18eec,
  QuoteDa52780eAc7e4e08826c2e4117ec4631,
  ContentSlugFc96dd5eBe0342b280f229754640da0d,
  ContentSlugF060081222d846b080ba45cd81ef829d,
  ContentSlug117d78d448ba4c22Ba9012a7d9aadaff,
  Header1dfe6d6120de4157849477270998c487,
  Header5047f59c7e764a2d86af3736d9faf343,
  TitleBf4f9dc39e1d43f496f282bc670e3703,
  As62da5cc75af643e6A1ba50e41258508a,
  TypeC653df7797e4462493afAd11e96e66cd
}

export default Components;